export default __webpack_public_path__ + "static/media/lock.7eee195e.svg";